// start:ng42.barrel
export * from './reservation-association.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/reservation-association/index.ts